<script lang="ts">
  import { onMount } from 'svelte';
  import { Heading, Wrapper } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';
  import { page } from '$app/stores';

  export let properties: UseFormattedProps;
  let showMore = false;

  let amoutToDisplay = 0;

  onMount(() => {
    if (document.body.clientWidth < 768) {
      amoutToDisplay = 6;
    } else {
      amoutToDisplay = 12;
    }
  });
</script>

<Wrapper style="background:var(--vlt-lp-secondary);">
  <div class="brands-section">
    {#if properties?.heading}
      {#if $page.data?.pageType === 'marketing'}
        <Heading type="h2">
          {@html properties.heading}
        </Heading>
      {:else}
        <Heading type="h2" css="color:var(--vlt-lp-secondary-text)">
          {@html properties.heading}
        </Heading>
      {/if}
    {/if}

    {#if properties?.images?.length}
      <div class="images {properties?.images.length >= 3 ? 'fullWidth' : ''}">
        {#each properties.images as image, index}
          {#if index < amoutToDisplay || showMore}
            <div class="image">
              <img src={image} alt="logo" loading="lazy" />
            </div>
          {/if}
        {/each}
      </div>
      <div style="margin-top:45px;">
        {#if properties.images.length > amoutToDisplay}
          <button
            on:click={() => (showMore = !showMore)}
            class="text-sm"
            style="
            display: flex;
            padding: 8px 12px;
            justify-content: center;
            align-items: center;
            max-width: 358px;
            border-radius: var(--border-4, 4px);
            border: 1px solid transparent;
            width: 100%;
            margin:auto;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px;
            color: var(--color-primary, #8dc63f);
            text-decoration:underline;
            cursor:pointer;"
          >
            {#if showMore}
              Show Less
            {:else}
              Show More
            {/if}
          </button>
        {/if}
      </div>
    {/if}
  </div>
</Wrapper>

<style>
  .brands-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0px 15px;
  }
  .images {
    margin-top: 60px;
    width: 100%;
    max-width: 1200px;
    justify-content: center;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(176px, 300px));
    gap: 16px;
  }
  .image {
    width: auto;
    height: 75px;
    position: relative;
    align-items: center;
    display: flex;
    padding: 15px;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #ebedef;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 4px;
  }
  .images.fullWidth {
    grid-template-columns: repeat(auto-fit, minmax(176px, 1fr));
  }
  img {
    width: 155px;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 768px) {
    .images {
      margin-top: 40px;
    }
    .brands-section {
      text-align: center;
    }
  }
  @media screen and (max-width: 660px) {
    .images {
      grid-template-columns: repeat(auto-fit, minmax(176px, 1fr));
    }
  }
</style>
